import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/design-system/saved")({
  component: () => <Navigate to="/admin/design-system/saved" />,
});
